import React, { useState, useEffect, Dispatch } from "react";
import { Tooltip } from "@mui/material";
import { AiFillInfoCircle } from "react-icons/ai";
import { useTranslation } from "react-i18next";

import { TiArrowSortedDown as SortedDown, TiArrowSortedUp as SortedUp } from "react-icons/ti";

import { SortColumn, SortType } from "../../export";

import { Column } from "../..";

import useStyles from "./styles";

type Props = {
  column: Column;
  showSort: boolean;
  columnClicked: SortColumn;
  setColumnClicked: Dispatch<React.SetStateAction<SortColumn>>;
};

const ColumnHeader = (props: Props) => {
  const { column, columnClicked, setColumnClicked, showSort } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [style, setStyle] = useState<{}>({});
  const [opacityIcon, setOpacityIcon] = useState(0);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    columnClicked.columnName != column?.name && setOpacityIcon(0);
  }, [columnClicked]);

  const renderContent = () => {
    if (showSort && !column?.hideSort) {
      return (
        <Tooltip placement="top" title={`${translate("sortBy")} ${column?.title}`}>
          <div
            className={classes.container}
            onMouseEnter={() => {
              setStyle({ color: "gray" });
              setOpacityIcon(1);
            }}
            onMouseLeave={() => {
              setStyle({});
              columnClicked.columnName != column?.name && setOpacityIcon(0);
            }}
            onClick={() => {
              clicked
                ? setColumnClicked({
                    columnName: column?.name,
                    direction: SortType.DESC,
                    columnToSorting: column?.associationColumnSettings?.columnToSorting,
                  })
                : setColumnClicked({
                    columnName: column?.name,
                    direction: SortType.ASC,
                    columnToSorting: column?.associationColumnSettings?.columnToSorting,
                  });
              setClicked(!clicked);
            }}
            style={{ width: column?.style?.width, padding: 0, margin: 0 }}
          >
            <span style={{ ...style }} className={classes.title}>
              {column?.title}
            </span>
            <div className={classes.iconButton} style={{ opacity: opacityIcon }}>
              {columnClicked.direction === SortType.DESC ? (
                <SortedDown size={20} color="#808080" />
              ) : (
                <SortedUp size={20} color="#808080" />
              )}
            </div>
          </div>
        </Tooltip>
      );
    }

    if (column?.info) {
      return (
        <>
          <span className={classes.title}>{column?.title}</span>
          <Tooltip placement="top" className={classes.tooltipInfo} title={column?.info}>
            <span>
              <AiFillInfoCircle color="#667085" />
            </span>
          </Tooltip>
        </>
      );
    }

    return <span className={classes.title}>{column?.title}</span>;
  };

  return renderContent();
};

export default ColumnHeader;
